import {Nullish} from 'shared/web';

import {numberFormatter} from './numberFormatter';

export const powerFormatter = (value: number | Nullish) => `${numberFormatter(value)} kW`;
